import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/types';
import { cents } from '@systemeio/util';
import { ChartData } from 'chart.js';
import { AffiliateChartInterface } from 'modules/affiliate/types/affiliate-statistic-interface';
import { getAffiliateChartColors } from 'modules/affiliate/utils/get-affiliate-chart-color';
import { getChartValue } from 'modules/affiliate/utils/get-chart-value';
import { useMemo } from 'react';
import { CurrencyNameEnum } from 'shared/enums/currency-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { toShortDate } from 'shared/utils/date-time-format';
export const useAffiliateChartData = t0 => {
  const $ = _c(16);
  const {
    chartData,
    currencies,
    allCurrencies
  } = t0;
  const {
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t1;
  bb0: {
    if (!chartData) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          labels: [],
          datasets: []
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== chartData.days || $[2] !== intlLocale) {
      t2 = Object.keys(chartData.days).map(el => toShortDate(el, intlLocale));
      $[1] = chartData.days;
      $[2] = intlLocale;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== allCurrencies || $[5] !== chartData.days || $[6] !== currencies || $[7] !== t) {
      let t4;
      if ($[9] !== allCurrencies || $[10] !== chartData.days || $[11] !== t) {
        t4 = cur => {
          const {
            fill,
            hover
          } = getAffiliateChartColors(cur, allCurrencies);
          return {
            data: Object.keys(chartData.days).map(el_0 => getChartValue(chartData.days[el_0]?.[cur] ?? cents(0)) / 100),
            label: t(CurrencyNameEnum[cur]),
            backgroundColor: fill,
            hoverBackgroundColor: hover
          };
        };
        $[9] = allCurrencies;
        $[10] = chartData.days;
        $[11] = t;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      t3 = currencies.map(t4);
      $[4] = allCurrencies;
      $[5] = chartData.days;
      $[6] = currencies;
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[13] !== t2 || $[14] !== t3) {
      t4 = {
        labels: t2,
        datasets: t3
      };
      $[13] = t2;
      $[14] = t3;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t1 = t4;
  }
  return t1;
};